import * as React from 'react';
import { UserState } from 'app/reducers/state';
import { API_BASE, API_CHARTBACK, executeQueryGetAuth } from 'app/utils/api';
import { Spinner, Callout, Intent, Button, H3, TextArea, Collapse } from '@blueprintjs/core';
import { find, each } from 'lodash';
import ReactTable from 'react-table';
import { Score } from '../Score';
import { CSVLink } from "react-csv";
import { DoneMarker } from '../DoneMarker';
import { NotDoneMarker } from '../NotDoneMarker';
import * as superagent from 'superagent';
import { wasTutorialModuleCompleted } from '../../utils/scores';
import { SingleOverviewClassic } from '../SingleOverviewClassic';
import { SingleOverview } from '../SingleOverview';
import { formatDate } from 'app/utils';
import { CoachingPersonalView } from '../CoachingPersonalView';
import SingleUserLPView from '../SingleUserLPView';

// Memoized wrappers to prevent unnecessary re-renders
const MemoizedSingleUserLPView = React.memo(SingleUserLPView);
const MemoizedSingleOverview = React.memo(SingleOverview);
const MemoizedSingleOverviewClassic = React.memo(SingleOverviewClassic);
const MemoizedCoachingPersonalView = React.memo(CoachingPersonalView);

const STUDENT_NAME_STYLE = {
    color: 'blue',
    cursor: 'pointer'
}

interface Props {
    user: UserState;
    showProfessors?: boolean; // If this is missing, assume that we shouldn't
    selectedClass?: string;
};

interface State {
    loadingClassData: boolean;
    loadingStudentData: boolean;
    classEnrollment: any;
    classDetails: ClassDetails;
    studentDataSet: {};
    selectedStudent: string | undefined;
    downloadDataHolder: any;
    selectedAssignment: string;
    coachingCache: string;
    savingCoaching: boolean;
    isHistoryVisible: boolean;
    textareaValue: string;
}

interface ClassDetails {
    class?: string;
    code?: string;
    id?: string;
    school?: string;
    classType?: number;
}

export class Coaching extends React.Component<Props, State> {

    state: State = {
        loadingClassData: true,
        loadingStudentData: true,
        classEnrollment: {},
        classDetails: {},
        studentDataSet: {},
        selectedStudent: undefined,
        downloadDataHolder: [],
        selectedAssignment: '',
        coachingCache: '',
        savingCoaching: false,
        isHistoryVisible: false,
        textareaValue: ''
    }
    tableRef04: ReactTable<unknown> | null | undefined | any;
    tableRef03: ReactTable<unknown> | null | undefined | any;
    tableRef02: ReactTable<unknown> | null | undefined | any;
    tableRef01: ReactTable<unknown> | null | undefined | any;
    csvLink: any;
    textareaRef: React.RefObject<any>;

    constructor(props: Props) {
        super(props);
        this.textareaRef = React.createRef<any>();
    }

    componentDidMount() {
        this.initClassData();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.selectedClass !== undefined && this.props.selectedClass !== undefined) {
            if (prevProps.selectedClass !== this.props.selectedClass) {
                this.initClassData();
            }
        }
    }

    initClassData = () => {
        this.setState({
            loadingClassData: true,
            loadingStudentData: true,
            classEnrollment: {},
            classDetails: {},
            studentDataSet: {},
            selectedStudent: undefined,
            downloadDataHolder: []
        });

        const query = `https://tgwz7xpofb.execute-api.us-east-1.amazonaws.com/dev/build?classID=${this.props.selectedClass}`;

        superagent.
            get(query).
            end((error:any, response:any) => {
                if (error) {
                    console.error(error);
                }
            }); 

        const classID = this.getClassID();

        executeQueryGetAuth("class/" + classID.toString() + "/details", {}, this.props.user, (classDetailsResponse) => {
            const classDetails = classDetailsResponse.body;

            executeQueryGetAuth("class/" + classID.toString() + "/students", {}, this.props.user, (response) => {

                let classEnrollmentBase: any[] = [];

                if (this.props.user.level === 3) {
                    classEnrollmentBase = response.body;
                }
                else {
                    each(response.body, en => {
                        if (en.level === 1) {
                            classEnrollmentBase.push(en);
                        }
                    })
                }

                this.setState({
                    loadingClassData: false
                });

                let allStudentIds = [];

                // Now Load all the students
                each(response.body, student => {
                    const studentID = student["id"];

                    //@ts-ignore
                    allStudentIds.push(studentID);
                });



                let studentDataGatherPromises: any[] = [];

                studentDataGatherPromises.push(
                    new Promise((resolve, reject) => {
                        superagent.
                            get(API_CHARTBACK() + '?userIDSet=' + allStudentIds.join(",") + '&mock=progress_overview_all').
                            end((error:any, response:any) => {
                                let responses = [];

                                for (let i = 0; i < response.body.userData.length; i++) {
                                    const binID = response.body.userData[i]['user'];
                                    const binDATA = response.body.userData[i]['data'];

                                    //@ts-ignore
                                    responses.push({
                                        id: binID, payload: binDATA
                                    })
                                }

                                resolve(responses);
                            }); 
                    })
                );

                // Now Load all the students
                // each(response.body, student => {
                //     const studentID = student["id"];

                //     studentDataGatherPromises.push(
                //         new Promise((resolve, reject) => {
                //             superagent.
                //                 get(API_CHARTBACK() + '?userID=' + studentID + '&mock=progress_overview').
                //                 end((error:any, response:any) => {
                //                     resolve({
                //                         id: studentID, payload: JSON.parse(response.text)
                //                     });
                //                 }); 
                //         })
                //     );
                // });

                Promise.all(studentDataGatherPromises).then((result) => {

                    classEnrollmentBase = classEnrollmentBase.sort((a,b) => {
                            if (a === b) {
                            return 0;
                          }
          
                          return a.last.toUpperCase() > b.last.toUpperCase() ? 1 : -1;
                    });

                    // Load coaching data for each student
                    const coachingPromises = classEnrollmentBase.map((student, index) => {
                        return new Promise((resolve) => {
                            executeQueryGetAuth(`data/coaching/${student.id}`, {}, this.props.user, (coachingResponse) => {
                                try {
                                    const coachingData = JSON.parse(coachingResponse.text);
                                    let lastCoachingDate = null;
                                    
                                    if (Array.isArray(coachingData) && coachingData.length > 0) {
                                        // Find the most recent coaching entry
                                        const sortedCoaching = coachingData.sort((a, b) => {
                                            const dateA = new Date(a.created || a.feedbackTime || 0);
                                            const dateB = new Date(b.created || b.feedbackTime || 0);
                                            return dateB.getTime() - dateA.getTime();
                                        });
                                        
                                        lastCoachingDate = sortedCoaching[0].created || sortedCoaching[0].feedbackTime;
                                    }
                                    
                                    resolve({ index, lastCoachingDate });
                                } catch (e) {
                                    resolve({ index, lastCoachingDate: null });
                                }
                            });
                        });
                    });

                    Promise.all(coachingPromises).then((coachingResults) => {
                        // Apply coaching data to students
                        coachingResults.forEach(({ index, lastCoachingDate }) => {
                            classEnrollmentBase[index].lastCoachingDate = lastCoachingDate;
                        });

                        for(let i = 0; i < classEnrollmentBase.length; i++) {
                            const studentID = classEnrollmentBase[i]["id"];

                            let previousStudent = i - 1;
                            let nextStudent     = i + 1;

                            if (nextStudent >= classEnrollmentBase.length) {
                                nextStudent = 0;
                            }

                            if (previousStudent < 0) {
                                previousStudent = classEnrollmentBase.length - 1;
                            }

                            classEnrollmentBase[i]["nextStudentID"] = classEnrollmentBase[nextStudent]["id"];
                            classEnrollmentBase[i]["previousStudentID"] = classEnrollmentBase[previousStudent]["id"];

                            for (let c = 0; c < result.length; c++) {
                                if (studentID === result[c]["id"]) {
                                    classEnrollmentBase[i]["overview"] = result[c].payload;
                                }
                            }
                        }

                        this.setState({
                            loadingStudentData: false,
                            classEnrollment: classEnrollmentBase,
                            classDetails
                        });
                    });
                });
            });
        });
    }

    getClassID = () => {
        const {
            selectedClass,
            user
        } = this.props;

        if (selectedClass === undefined) {
            return user.class;
        }

        return selectedClass;
    }

    // Determine if this is a classic class (classType === 2) or regular class
    isClassicClass = () => {
        const {
            classDetails
        } = this.state;

        console.log('Class details:', classDetails);
        console.log('User classicMode:', this.props.user.classicMode);

        // Check if classDetails has a classType property indicating classic mode
        if (classDetails && typeof classDetails.classType === 'number') {
            return classDetails.classType === 2;
        }

        // Fallback to user's classicMode if class details don't specify
        return this.props.user.classicMode === 2;
    }

    getScenarioBestScore = (scenarioOverview: any) => {
        if (scenarioOverview === undefined) return "";

		if (scenarioOverview["best-score"] === "" || scenarioOverview["best-score"] === undefined || scenarioOverview["best-score"] === "0") {
			return "Not Played";
		}
		const bestScore = parseFloat(scenarioOverview["best-score"]);
        
        return Math.round(bestScore).toString();
    }

    getScenarioInitilalScore = (scenarioOverview: any) => {
        if (scenarioOverview === undefined) return "";

		if (scenarioOverview["best-score"] === "" || scenarioOverview["best-score"] === undefined || scenarioOverview["best-score"] === "0") {
			return "Not Played";
		}

		const bestScore = parseFloat(scenarioOverview["initial-score"]);

		return Math.round(bestScore).toString();
    }

    getExportData = () => {
        const {
            classEnrollment
        } = this.state;

        let dataBuffer:any[] = [];

        each(classEnrollment, classEnrolle => {

            const scene_2_bc = this.getStudentOverview("scene_2_bc", classEnrolle["id"]);
            const scene_1_bc = this.getStudentOverview("scene_1_bc", classEnrolle["id"]);
            const scene_4_bc = this.getStudentOverview("scene_4_bc", classEnrolle["id"]);

            let isTutorialFinished = wasTutorialModuleCompleted(scene_1_bc, scene_2_bc, scene_4_bc);

            dataBuffer.push({
                "Name": classEnrolle["first"] + " " + classEnrolle["last"],
                "Email": classEnrolle["email"],
                "Purchased": (classEnrolle["subscription"] === 1) ? "Yes" : "No",
                "Completed Intent-based Communication": (isTutorialFinished) ? "Yes" : "No",
                "Scenario 1 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_1_initial"]),
                "Scenario 1 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_1"]),
                "Scenario 1 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_1_assess"]),
                "Scenario 2 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_2_initial"]),
                "Scenario 2 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_2"]),
                "Scenario 2 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_2_assess"]),
                "Scenario 3 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_3_initial"]),
                "Scenario 3 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_3"]),
                "Scenario 3 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_3_assess"]),
                "Scenario 5 Initial Play": this.getScenarioInitilalScore(classEnrolle["overview"]["classic_scenario_5_initial"]),
                "Scenario 5 Best Explore Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_5"]),
                "Scenario 5 Best Assess Play": this.getScenarioBestScore(classEnrolle["overview"]["classic_scenario_5_assess"])
            });
        })

        return dataBuffer;
    }

    handlePreviousStudent = () => {
        const {
            classEnrollment,
            selectedStudent
        } = this.state;

        const matchingStudent = find(classEnrollment, student => {
            return student.id === selectedStudent
        });

        this.setState({
            selectedStudent: matchingStudent.previousStudentID,
            isHistoryVisible: false,
            textareaValue: '' // Clear the textarea
        });
    }

    handleNextStudent = () => {
        const {
            classEnrollment,
            selectedStudent
        } = this.state;

        const matchingStudent = find(classEnrollment, student => {
            return student.id === selectedStudent
        });

        this.setState({
            selectedStudent: matchingStudent.nextStudentID,
            isHistoryVisible: false,
            textareaValue: '' // Clear the textarea
        });
    }

    selectStudent = (student: any) => {
        console.log('Selecting student:', student);
        console.log('Current classEnrollment:', this.state.classEnrollment);
        this.setState({
            selectedStudent: student,
            textareaValue: '' // Clear the textarea when selecting a new student
        });
    }

    getStudentOverview = (scenario: string, studentID: string) => {
        const {
            classEnrollment
        } = this.state;

        const matchingStudent = find(classEnrollment, student => {
            return student.id === studentID
        });

        return matchingStudent["overview"][scenario];
    }

    getStudentTableColumns = () => {
        const {
            classEnrollment
        } = this.state;

        return [{
            Header: "Student",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });

                return <span style={STUDENT_NAME_STYLE} onClick={() => {
                    this.selectStudent(props.value);
                }}>
                    {student.first + " " + student.last}
                </span>
            },
            sortMethod: (a, b) => {
                if (a === b) {
                  return 0;
                }

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === a
                });

                const student2 = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === b
                });

                return student.last.toUpperCase() > student2.last.toUpperCase() ? 1 : -1;
            }
        },{
            Header: "Email",
            accessor: "email"
        },{
            Header: "Purchased",
            accessor: "subscription",
            Cell: (props) => {
                return (props.value === 1) ? <DoneMarker /> : <NotDoneMarker />
            }
        },{
            Header: "Last Coaching Date",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;
                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });
                
                if (student && student.lastCoachingDate) {
                    try {
                        return formatDate(new Date(student.lastCoachingDate).toString());
                    } catch (e) {
                        return "Invalid Date";
                    }
                }
                
                return "No Coaching";
            }
        },{
            Header: "Coach",
            accessor: "id",
            Cell: (props) => {
                return <Button intent={Intent.PRIMARY} text="Start" onClick={() => {
                    this.selectStudent(props.value);
                }} />
            }
        }];
    }

    getTutorialColumns = () => {
        const {
            classEnrollment
        } = this.state;

        return [{
            Header: "Student",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });

                return <span style={STUDENT_NAME_STYLE} onClick={() => {
                    this.selectStudent(props.value);
                }}>
                    {student.first + " " + student.last}
                </span>
            },
            sortMethod: (a, b) => {
                if (a === b) {
                  return 0;
                }

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === a
                });

                const student2 = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === b
                });

                return student.last.toUpperCase() > student2.last.toUpperCase() ? 1 : -1;
            }
        },{
            Header: "Email",
            accessor: "email"
        },{
            Header: "Getting Work Done",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview("scene_1_bc", props.value);

                if (overview === undefined) {
                    return <NotDoneMarker />
                }

                const bestScoreAsFloat = parseFloat(overview['best-score']);

                if (bestScoreAsFloat === 100.0) {
                    return <DoneMarker />
                }

                return <NotDoneMarker />
            }
        },{
            Header: "Getting Access to Hidden Ideas",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview("scene_2_bc", props.value);

                if (overview === undefined) {
                    return <NotDoneMarker />
                }

                const bestScoreAsFloat = parseFloat(overview['best-score']);

                if (bestScoreAsFloat === 100.0) {
                    return <DoneMarker />
                }

                return <NotDoneMarker />
            }
        },{
            Header: "Changing Your Informal Power",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview("scene_4_bc", props.value);

                if (overview === undefined) {
                    return <NotDoneMarker />
                }

                const bestScoreAsFloat = parseFloat(overview['best-score']);

                if (bestScoreAsFloat === 100.0) {
                    return <DoneMarker />
                }

                return <NotDoneMarker />
            }
        }];
    }

    getStudentTableColumnsForScenarios = (baseScenario: string) => {
        const {
            classEnrollment
        } = this.state;

        if (baseScenario === "tutorial") {
            return this.getTutorialColumns();
        }

        return [{
            Header: "Student",
            accessor: "id",
            Cell: (props) => {
                const studentID = props.value;

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === studentID
                });

                return <span style={STUDENT_NAME_STYLE} onClick={() => {
                    this.selectStudent(props.value);
                }}>
                    {student.first + " " + student.last}
                </span>
            },
            sortMethod: (a, b) => {
                if (a === b) {
                  return 0;
                }

                const student = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === a
                });

                const student2 = find(classEnrollment, enrollmentEntry => {
                    return enrollmentEntry.id === b
                });

                return student.last.toUpperCase() > student2.last.toUpperCase() ? 1 : -1;
            }
        },{
            Header: "Email",
            accessor: "email"
        },{
            Header: "Initial Explore Play",
            accessor: "id",
            Cell: (props) => {

                const overview = this.getStudentOverview(baseScenario + "_initial", props.value);

                if (overview === undefined) return <span>-</span>

                return <Score score={overview['initial-score']} base={overview['best-max']} />
            }
        },{
            Header: "Best Explore Play",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview(baseScenario, props.value);

                if (overview === undefined) return '';

                return <Score score={overview['best-score']} base={overview['best-max']} />
            }
        },{
            Header: "Best Assess Play",
            accessor: "id",
            Cell: (props) => {
                const overview = this.getStudentOverview(baseScenario + "_assess", props.value);

                if (overview === undefined) return '';

                return <Score score={overview['best-score']} base={overview['best-max']} />
            }
        }];
    }

    renderCalloutTitle = (title: string, ref: any): any => {
        const {
            classDetails
        } = this.state;
        
        const showButton = title.includes("Your");

        return <span>
            {title}
            <span style={{marginLeft: '5px'}}>
                {showButton ?
                <Button text="Download Data" onClick={() => {
                    this.setState({
                        downloadDataHolder: this.getExportData()
                    }, () => {
                        this.csvLink.link.click();
                    });
                }} /> : undefined}
                <CSVLink style={{display: 'none'}} ref={(r) => this.csvLink = r} filename={classDetails.class!.replace(" ", "-") + "-data.csv"} data={this.state.downloadDataHolder} target="_blank">Download Data</CSVLink>
            </span>
        </span>
    }

    renderNavigation = () => {
		const {
			user
		} = this.props;

		if (user.level === 1) return undefined;

		return <span>
            <Button style={{marginBottom: '10px', marginRight: '10px', marginLeft: '10px'}} intent={Intent.PRIMARY} text="Previous Student" onClick={() => {
                    this.handlePreviousStudent();
            }} />

            <Button style={{marginBottom: '10px'}} intent={Intent.PRIMARY} text="Next Student" onClick={() => {
                    this.handleNextStudent();
            }} />
		</span>
	}

    renderAssignmentSelection = () => {

    }

    handlePostCoaching(uid: string, coaching: string, createdBy: string, callback: any) {
        console.log('handlePostCoaching called with:');
        console.log('uid:', uid);
        console.log('coaching:', coaching);
        console.log('createdBy:', createdBy);
        console.log('API_BASE():', API_BASE());
        console.log('Full URL:', API_BASE() + 'data/coaching/post/' + uid);
        console.log('Token:', this.props.user.authenticationToken);
        
        superagent.
            post(API_BASE() + 'data/coaching/post/' + uid).
            field("coaching", coaching).
            field("createdBy", createdBy).
            set('Token', this.props.user.authenticationToken).
            end((error: any, response: any) => {
                console.log('API Response:');
                console.log('Error:', error);
                console.log('Response:', response);
                if (error) {
                    console.error('API Error:', error);
                } else {
                    console.log('API Success:', response.status, response.body);
                }
                callback();
            });
    }

    handlePostClick = () => {
        this.setState({
            savingCoaching: true
        });

        // Use the state value instead of ref
        const currentValue = this.state.textareaValue;
        console.log('Posting coaching text from state:', currentValue);
        console.log('CurrentValue length:', currentValue.length);
        
        if (!currentValue.trim()) {
            console.warn('No text to post - currentValue is empty or whitespace only');
            this.setState({
                savingCoaching: false
            });
            return;
        }

        console.log('About to post coaching text:', currentValue);
        this.handlePostCoaching(this.state.selectedStudent, currentValue, this.props.user.id.toString(), () => {
            console.log('Coaching post completed');
            this.setState({
                savingCoaching: false,
                isHistoryVisible: false,
                textareaValue: '' // Clear the textarea
            });
        });
    }

	render() {
        const {
            loadingClassData,
            loadingStudentData,
            classEnrollment,
            selectedStudent,
            classDetails,
            savingCoaching
        } = this.state;

        if (loadingClassData || loadingStudentData) return <Spinner />

        if (selectedStudent !== undefined) {
            console.log('Rendering selected student:', selectedStudent);
            console.log('Class enrollment data:', classEnrollment);
            
            const matchingStudent = find(classEnrollment, student => {
                return student.id === selectedStudent
            });

            console.log('Matching student found:', matchingStudent);

            // Add error handling for missing student data
            if (!matchingStudent) {
                console.error('No matching student found for ID:', selectedStudent);
                return <span>
                    <Button style={{marginBottom: '10px'}} intent={Intent.NONE} text="Close Coaching" onClick={() => {
                        this.selectStudent(undefined);
                    }} />
                    <Callout intent={Intent.DANGER}>
                        <strong>Error:</strong> Student data not found. Please try again.
                    </Callout>
                </span>
            }

            return <span>
                <Button style={{marginBottom: '10px'}} intent={Intent.NONE} text="Close Coaching" onClick={() => {
                    this.selectStudent(undefined);
                }} />

                <H3>{matchingStudent.first + " " + matchingStudent.last}'s Overview</H3>

                {this.renderNavigation()}

                <Callout>
                    <strong>Coaching:</strong>
                    {savingCoaching ? <Spinner /> :                     <TextArea
                        ref={this.textareaRef}
                        growVertically={true}
                        large={true}
                        intent={Intent.PRIMARY}
                        style={{width: '100%', marginBottom: '5px'}}
                        value={this.state.textareaValue}
                        onChange={(event) => {
                            this.setState({
                                textareaValue: event.target.value
                            });
                        }}
                    />}
                </Callout>
                
                <Button style={{marginBottom: '10px', marginTop: '10px'}} intent={Intent.SUCCESS} text="Post" onClick={this.handlePostClick} />

                <h3>Loose Journal Responses</h3>
                <MemoizedSingleUserLPView user={this.props.user} targetUserID={selectedStudent} />
                
                <Button style={{display: 'block', marginTop: '10px', marginBottom: '10px'}} onClick={() => {
                    this.setState({
                        isHistoryVisible: !this.state.isHistoryVisible
                    });
                }}>
                    {this.state.isHistoryVisible ? "Hide" : "Show"} coaching history
                </Button>
                <Collapse isOpen={this.state.isHistoryVisible}>
                    <MemoizedCoachingPersonalView targetUser={selectedStudent} user={this.props.user} />
                </Collapse>
                
                {/* Use appropriate overview component based on class type */}
                {matchingStudent ? (
                    this.isClassicClass() ? (
                        <MemoizedSingleOverviewClassic 
                            targetUserData={matchingStudent} 
                            userTutorial={matchingStudent.tutorial || '0'} 
                            goToNext={this.handleNextStudent} 
                            goToPrevious={this.handlePreviousStudent} 
                            showNavigation={true} 
                            hideDownloadPrompt={true} 
                            user={this.props.user} 
                            forceNoEdit={true} 
                            targetUserID={selectedStudent} 
                        />
                    ) : (
                        <MemoizedSingleOverview 
                            user={this.props.user} 
                            forceNoEdit={true} 
                            targetUserID={selectedStudent}
                            hideDownloadPrompt={true}
                            showNavigation={true}
                            goToNext={this.handleNextStudent}
                            goToPrevious={this.handlePreviousStudent}
                        />
                    )
                ) : (
                    <Callout intent={Intent.WARNING}>
                        <strong>Warning:</strong> Student data is missing. Some features may not work properly.
                    </Callout>
                )}
            </span>
        }
        
        return <span>
            <Callout style={{marginBottom: '20px'}} icon={"info-sign"} intent={Intent.NONE} title={classDetails.class}>
                <b>Class Name:</b> {classDetails.class}
                <br/>
                <b>Class School:</b> {classDetails.school}
                <br />
                <b>Class Invite Code:</b> {classDetails.code}
            </Callout>
            <Callout title={this.renderCalloutTitle("Your Students", this.tableRef01)}>
                <ReactTable ref={(r) => this.tableRef01 = r} data={classEnrollment} pageSize={classEnrollment.length} showPageSizeOptions={false} showPagination={false} columns={this.getStudentTableColumns()} defaultSorted={[{
                    id   : 'id',
                    desc : false,
                }]} />
            </Callout>
        </span>
	}
}
